import React, { useContext } from 'react';
import { ApplyTemplateBtnContainer, ApplyTemplateBtn } from './styles';
// element context API
import { ElementContext } from '../../context/elementContext';
import { PageElementsContext } from '../../context/pageElementsContext';
import { DESIGN_AREA_TEMPLATES_TAB } from '../../containers/SidebarMenu/translationValues';
import { useTranslation } from 'react-i18next';

const NAMESPACES = ['DESIGN_AREA_TEMPLATES_TAB'];
const ApplyTemplate = ({ template, text }) => {
  const { clickElement } = useContext(ElementContext);
  const { t } = useTranslation(NAMESPACES);
  const { handlePageHistory } = useContext(PageElementsContext);

  const handleElementClick = async () => {
    let pageDetails = {
      templateDetails: template,
      actionType: 'replace-template',
    };
    handlePageHistory([], 'applyAll');
    clickElement(pageDetails);
  };

  return (
    <ApplyTemplateBtnContainer>
      <ApplyTemplateBtn onClick={handleElementClick}>{t(DESIGN_AREA_TEMPLATES_TAB.APPLY_ALL_PAGES_BUTTON.key, DESIGN_AREA_TEMPLATES_TAB.APPLY_ALL_PAGES_BUTTON.value)}</ApplyTemplateBtn>
    </ApplyTemplateBtnContainer>
  );
};

export default ApplyTemplate;
